import React from 'react';
import './LegalModal.css';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: 'light' | 'dark';
}

export const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  onClose,
  theme,
}) => {
  if (!isOpen) return null;

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={e => e.stopPropagation()}>
        <div className="legal-modal-header">
          <h2>이용약관</h2>
          <button className="legal-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="legal-modal-content">
          <div className="legal-intro">
            <p>
              차트 트레이너('이하 '서비스') 이용약관에 오신 것을 환영합니다.
            </p>
            <p>
              본 약관은 서비스를 이용함에 있어 서비스와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>제1조 (목적)</h3>
            <p>
              본 약관은 차트 트레이너가 제공하는 주식 매매 연습 게임 서비스(이하 "서비스")의 이용과 관련하여 
              서비스와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>제2조 (정의)</h3>
            <ul>
              <li>
                <strong>"서비스"</strong>란 차트 트레이너가 제공하는 주식 매매 연습을 위한 교육용 게임 서비스를 의미합니다.
              </li>
              <li>
                <strong>"이용자"</strong>란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 의미합니다.
              </li>
              <li>
                <strong>"회원"</strong>이란 서비스에 회원등록을 하고 서비스를 이용하는 자를 의미합니다.
              </li>
              <li>
                <strong>"게임"</strong>이란 서비스 내에서 제공되는 가상의 주식 매매 시뮬레이션을 의미합니다.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제3조 (서비스의 성격)</h3>
            <p>
              본 서비스는 주식 매매 연습을 위한 <strong>교육용 게임</strong>입니다.
            </p>
            <ul>
              <li>실제 금융 투자와 무관하며 <strong>가상의 데이터</strong>를 사용합니다.</li>
              <li>게임 내 랭킹 및 데이터는 <strong>서비스 정책에 따라 변경</strong>될 수 있습니다.</li>
              <li>서버 점검, 업데이트 등으로 일시적으로 서비스가 중단될 수 있습니다.</li>
            </ul>
            <div style={{ 
              marginTop: '16px',
              padding: '12px',
              backgroundColor: theme === 'dark' ? '#2a1a1a' : '#fff3e0',
              border: `1px solid ${theme === 'dark' ? '#ff6b6b' : '#ff9800'}`,
              borderRadius: '6px',
            }}>
              <p style={{ 
                fontSize: '14px',
                color: theme === 'dark' ? '#ff6b6b' : '#e65100',
                fontWeight: 'bold',
                margin: '0 0 8px 0',
              }}>
                ⚠️ 금융투자업법 관련 안내
              </p>
              <p style={{ 
                margin: '0',
                fontSize: '13px', 
                color: theme === 'dark' ? '#ff6b6b' : '#d84315',
                lineHeight: '1.6',
              }}>
                본 서비스는 금융투자업법에 따른 투자자문업, 투자일임업, 집합투자업 등에 해당하지 않으며, 
                실제 투자 조언이나 투자 권유를 제공하지 않습니다. 게임 내 AI 분석 결과는 교육 목적의 
                참고용이며, 실제 투자 결정에 사용해서는 안 됩니다. 실제 투자로 인한 손실에 대해서는 
                본 서비스가 책임을 지지 않습니다.
              </p>
            </div>
          </div>

          <div className="legal-section">
            <h3>제4조 (약관의 게시와 개정)</h3>
            <ul>
              <li>서비스는 본 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
              <li>서비스는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
              <li>약관이 개정되는 경우 서비스는 개정 내용을 시행일자 7일 전부터 공지합니다.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제5조 (회원가입)</h3>
            <ul>
              <li>이용자는 서비스가 정한 가입 양식에 따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</li>
              <li>서비스는 제1항과 같이 회원가입을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
                <ul>
                  <li>가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
                  <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
                  <li>기타 회원으로 등록하는 것이 서비스의 기술상 현저히 지장이 있다고 판단되는 경우</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제6조 (서비스의 제공 및 변경)</h3>
            <ul>
              <li>서비스는 다음과 같은 서비스를 제공합니다:
                <ul>
                  <li>가상 주식 매매 시뮬레이션 게임</li>
                  <li>랭킹 시스템</li>
                  <li>매매 내역 관리</li>
                  <li>기타 서비스가 추가로 개발하거나 제휴계약 등을 통해 제공하는 일체의 서비스</li>
                </ul>
              </li>
              <li>서비스는 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부를 변경할 수 있습니다.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제7조 (서비스의 중단)</h3>
            <ul>
              <li>서비스는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
              <li>서비스는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 서비스가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제8조 (회원의 의무)</h3>
            <ul>
              <li>이용자는 다음 행위를 하여서는 안 됩니다:
                <ul>
                  <li>신청 또는 변경 시 허위내용의 등록</li>
                  <li>타인의 정보 도용</li>
                  <li>서비스가 게시한 정보의 변경</li>
                  <li>서비스가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                  <li>서비스와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                  <li>서비스 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                  <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제9조 (개인정보보호)</h3>
            <p>
              서비스는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.
            </p>
            <p>
              서비스는 회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 
              불가피한 경우 선이용후결제 방식으로 필요한 최소한의 정보를 수집할 수 있습니다.
            </p>
            <p>
              서비스가 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.
            </p>
            <p>
              자세한 내용은 <strong>개인정보처리방침</strong>을 참고하시기 바랍니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>제10조 (면책조항)</h3>
            <ul>
              <li>서비스는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
              <li>서비스는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
              <li>서비스는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
              <li>서비스는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>제11조 (준거법 및 관할법원)</h3>
            <ul>
              <li>서비스와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다.</li>
              <li>서비스와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송에는 대한민국 법을 적용합니다.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>부칙</h3>
            <p>본 약관은 2026년 2월 1일부터 시행됩니다.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

